import { ValueFormatterParams, ValueGetterParams } from 'ag-grid-community';
import { NO_VALUE } from '../../Ticker';
import { formatLarge, isNotNil } from '@benzinga/utils';
import { absColDef, AdvancedColDef } from '../helpers/advancedHeader';
import { AbbreviationNumberFilter } from './AbbreviationNumberFilter';

export const ShortenedNumberColDef = (colDef: AdvancedColDef): AdvancedColDef => ({
  cellStyle: { textAlign: 'right' },
  filter: AbbreviationNumberFilter,
  valueFormatter: (data: ValueFormatterParams) => (isNotNil(data.value) ? formatLarge(Number(data.value)) : NO_VALUE),
  valueGetter: (params: ValueGetterParams) =>
    params.colDef.field && isNotNil(params.data[params.colDef.field]) ? Number(params.data[params.colDef.field]) : 0,
  ...colDef,
  ...absColDef(colDef),
});
